import React from "react";
import dayjs from "dayjs";
import './styles.scss'
import {Table, Text} from "@mantine/core";
import {IContainerDetailsData} from "../../../api/Shipment.ShipmentDetails/Shipment.ShipmentDetails.types";

interface Props {
    containers: IContainerDetailsData[],
    onContainerClick: (containerId:string)=>void,
}

function ContainerDetails(props: Props) {
    const {containers, onContainerClick} = props;
    const rows = containers.map((container) => {
        const {containerNumber, packageType, grossWeight, containerSize, productNumber, lastEvent, lastEventDate} = container;

        return (
            <tr key={containerNumber}>
                {/* <td><Text variant="link" size="sm" color="blue" sx={() => ({"&:hover": {cursor: "pointer"}})}
                          onClick={() => onContainerClick(containerNumber)}>{containerNumber}</Text></td> */}
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{containerNumber}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{containerSize}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{productNumber}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{packageType}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{grossWeight}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{lastEvent}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{dayjs(lastEventDate).format("MMM DD, YYYY")}</td>
            </tr>
        )
    });

    return (
        <Table striped>
            <thead>
            <tr>
                <th>Container #</th>
                <th>Size</th>
                <th>Product #</th>
                <th>Package Type</th>
                <th>Gross Weight</th>
                <th>Last Event</th>
                <th>Last Event Date</th>
            </tr>
            </thead>
            <tbody>{rows}</tbody>
        </Table>
    )
}

export default ContainerDetails;